$(function() {
    $('.js-pagination-button').on('click', function(e) {
        e.preventDefault();
        showMore(this);
        $('html').trigger('resize');
    });

    var selector = $('.js-grid-sort');
    var select = selector.find('.grid-sort select');

    select.on('change', function () {
        var sort = $(this).val();
        var grid = $(this).closest(selector).find('.grid');
        var items = grid.find('.grid__item');
        var countVis = grid.find('.grid__item:visible').length;
        var newItems = doSort(sort, items);

        window.items = items;
        window.newItems = newItems;

        grid.html('');

        $.each(newItems, function(key, value) {
            grid.append(
                value
            );
        });

        var all = items.slice(0, countVis);

        var equalise = new EqualiseHeight($('.js-equalise-height'));

        equalise.init();
        equalise.update();
    });

    var showMore = function(button) {
        var gridButton = $(button);
        var count = gridButton.data('count');

        // Update counts
        gridButton.parent().parent().find('.js-pagination-text span').html(count);

        // Show other items
        gridButton.prevAll('.grid').first().find('.grid__item--hidden').removeClass('grid__item--hidden');
        gridButton.prevAll('.grid').first().find('.grid__item').show();

        // Hide show more button
        gridButton.remove();
    };

    var doSort = function(sort, items) {
        var dataName = 'order_' + sort;

        return items.sort(function(a,b) {
            // Compare a to b. Dont compare a to a. that's fucking stupid.
            // phil
            if ($(a).data(dataName) > $(b).data(dataName)) {
                return 1;
            } else {
                return -1;
            }
        });
    };
});
